import React from 'react'
import { useQuery } from '@tanstack/react-query'
import { Navigate, useParams } from 'react-router'
import { AppRoutes } from '@core/AppRoutes'
import { ProfileFollowList } from '@core/Areas/FollowMe/Components/ProfileFollowList'
import { followMeProfileByIdQuery } from '@core/Areas/FollowMe/helpers/queries'
import { FollowListPageLoader } from '@core/Areas/FollowMe/Components/ProfileFollowList/Components/FollowListPageLoader'

export const ProfileFollowListPage = () => {
  const { profileId } = useParams<{ profileId: string }>()

  if (!profileId) {
    return <Navigate to={AppRoutes.BetLoop} />
  }

  return <ProfileFollowListPageComponent profileId={profileId} />
}

// ===============
// Local Component
// ===============

const ProfileFollowListPageComponent: React.FC<{ profileId: string }> = ({ profileId }) => {
  const { data, isLoading, isError } = useQuery(followMeProfileByIdQuery(profileId))

  if ((!isLoading && !data) || isError) {
    return <Navigate to={AppRoutes.BetLoop} />
  }

  if (isLoading || !data) {
    return <FollowListPageLoader />
  }

  return <ProfileFollowList profile={data} />
}
